import { render, staticRenderFns } from "./UpdateActivityDialog.vue?vue&type=template&id=0a9276b8&scoped=true&lang=pug&"
import script from "./UpdateActivityDialog.vue?vue&type=script&lang=ts&"
export * from "./UpdateActivityDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9276b8",
  null
  
)

export default component.exports